import React from 'react';
import PropTypes from 'prop-types';

const Share = ({ fill = '' }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.24158 0.324935C8.96988 0.65777 8.99252 1.12679 9.3095 1.43693L11.1608 3.248L6.79056 3.24844C3.05155 3.24844 0 6.23409 0 9.89191L0 13.1562C0 13.6131 0.395431 14 0.862879 14C1.33033 14 1.72576 13.6131 1.72576 13.1562L1.72576 9.89191L1.72881 9.7175C1.8222 7.05479 4.04611 4.93605 6.79056 4.93605L11.1261 4.93537L9.3167 6.61394C8.9811 6.94211 8.96407 7.44187 9.25409 7.78238C9.44533 7.97163 9.6686 8.07357 9.90016 8.07357C10.1331 8.07357 10.3244 8.00156 10.4908 7.83874L13.6475 4.91154C14.0723 4.51761 14.1153 3.87813 13.7648 3.43489L13.6692 3.32873L10.5232 0.250678C10.1816 -0.0835594 9.65112 -0.0835594 9.3095 0.250678L9.24158 0.324935Z"
      fill={fill || 'white'}
    />
  </svg>
);

Share.propTypes = {
  fill: PropTypes.string,
};

export default Share;
